import { render, staticRenderFns } from "./userSubscribe.vue?vue&type=template&id=2112c2cf&scoped=true"
import script from "./userSubscribe.vue?vue&type=script&lang=js"
export * from "./userSubscribe.vue?vue&type=script&lang=js"
import style0 from "./userSubscribe.vue?vue&type=style&index=0&id=2112c2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112c2cf",
  null
  
)

export default component.exports